//
// x = {a: 1, b_attributes: [{c: d}]}
//
// getIn(x, 'a') => 1
// getIn(x, 'b_attributes.0.c'.split('.')) => d
//
export const getIn = (obj, nestedField) =>
  nestedField.reduce((o, f) => o && o[f], obj)
